import { useCallback } from 'react';


const useNavigationHandler = ({ triggerMenuClick = false } = {}) => {
    const handleLinkClick = useCallback(() => {

        if (triggerMenuClick) {
            // Buscar el elemento hamburguesa y hacer clic en él para cerrar el menú
            const hamburgerElement = document.querySelector('.mxd-nav__hamburger');
            if (hamburgerElement) {
                hamburgerElement.click();
            }

            // Recargar la página después de 1300ms para resetear todas las dependencias
            setTimeout(() => {
                window.location.reload();
            }, 1300);
        } else {
            // Recargar la página después de 1300ms para resetear todas las dependencias
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }

    }, []);

    return { handleLinkClick };
};

export default useNavigationHandler;
